/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreateOrderCommand } from '../../models/create-order-command';
import { CreateOrderCommandResult } from '../../models/create-order-command-result';

export interface ApiNurseryManagerOrdersCreateOrderPost$Params {
      body?: CreateOrderCommand
}

export function apiNurseryManagerOrdersCreateOrderPost(http: HttpClient, rootUrl: string, params?: ApiNurseryManagerOrdersCreateOrderPost$Params, context?: HttpContext): Observable<StrictHttpResponse<CreateOrderCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiNurseryManagerOrdersCreateOrderPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CreateOrderCommandResult>;
    })
  );
}

apiNurseryManagerOrdersCreateOrderPost.PATH = '/api/NurseryManager/Orders/CreateOrder';
